<app-uni-page
  [parent]="this"
  *ngIf="isPageReady"
  pageTitle="Purchases: Purchase Orders {{ getTitle() }}"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
>
</app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex h-full flex-col">
    <div class="min-h-0 w-full flex-1">
      <div class="flex h-full flex-col">
        <div class="my-2 flex shrink-0 items-center gap-3">
          <p-selectButton [options]="allStatusesExt" [(ngModel)]="buttonPoStatus" dataKey="id" optionLabel="name"></p-selectButton>
          <button
            *ngIf="isCompletedOnly || isCompletedWithOpenQtyOnly"
            pButton
            type="button"
            class="p-button-raised p-button-sm"
            icon="pi pi-times-circle"
            [disabled]="!canForceCancel"
            (click)="forceCancelOpenQty()"
          >
            <span>Force Cancel Open Qty</span>
          </button>
        </div>
        <app-ag-grid gridId="purchaseOrdersGrid" [gridOptions]="poGridOptions" class="min-h-0 flex-1"></app-ag-grid>
      </div>
    </div>
    <div class="min-h-0 w-full flex-1">
      <p-tabView (onChange)="onTabChanged($event)" class="uni-tabview h-full w-full" styleclass="h-full">
        <p-tabPanel header="Purchase Order Details">
          <app-ag-grid [gridOptions]="podGroupGridOptions" [rowData]="podGroups"></app-ag-grid>
        </p-tabPanel>
        <p-tabPanel header="Job Orders">
          <div class="flex h-full flex-col">
            <div class="min-h-0 w-full flex-1">
              <app-ag-grid [gridOptions]="joGridOptions" [rowData]="jobOrders"></app-ag-grid>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
